module.exports = "<button *ngIf=\"loading !== true\" type=\"button\" class=\"w-10\" id=\"payButtonId\" (click)=\"onClickPay()\">{{'PaymentForm.PaymentButton' | translate}}</button>\n<button *ngIf=\"loading === true\" type=\"button\" class=\"w-10\" id=\"loadingButtonId\"><i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i></button>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/paysafe-checkout/paysafe-checkout.component.html
// module id = ../../../../../src/app/components/payment/paysafe-checkout/paysafe-checkout.component.html
// module chunks = main